import { render, staticRenderFns } from "./YoutubeVideoTopRow.vue?vue&type=template&id=0358870e&scoped=true&"
import script from "./YoutubeVideoTopRow.vue?vue&type=script&lang=js&"
export * from "./YoutubeVideoTopRow.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeVideoTopRow.vue?vue&type=style&index=0&id=0358870e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358870e",
  null
  
)

export default component.exports